import SigliveServiceV1 from 'Service/sigliveServiceV1';

const postSchedule = async ({ payload }) => {
  const { data } = await SigliveServiceV1({ method: 'POST', url: `/schedule`, data: payload });

  return data;
};

export default postSchedule;
